import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-camp-menu',
  templateUrl: './camp-menu.component.html',
  styleUrls: ['./camp-menu.component.scss']
})
export class CampMenuComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
